'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * From keppelen/react-facebook-login
                    */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _facebook = require('./facebook.scss');

var _facebook2 = _interopRequireDefault(_facebook);

var _FacebookLogin = require('./FacebookLogin');

var _FacebookLogin2 = _interopRequireDefault(_FacebookLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.w3.org/TR/html5/disabled-elements.html#disabled-elements
var _shouldAddDisabledProp = function _shouldAddDisabledProp(tag) {
  return ['button', 'input', 'select', 'textarea', 'optgroup', 'option', 'fieldset'].indexOf((tag + '').toLowerCase()) >= 0;
};

var FacebookLoginWithButton = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(FacebookLoginWithButton, _React$Component);

  function FacebookLoginWithButton() {
    (0, _classCallCheck3.default)(this, FacebookLoginWithButton);
    return (0, _possibleConstructorReturn3.default)(this, (FacebookLoginWithButton.__proto__ || (0, _getPrototypeOf2.default)(FacebookLoginWithButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(FacebookLoginWithButton, [{
    key: 'style',
    value: function style() {
      var defaultCSS = this.constructor.defaultProps.cssClass;
      if (this.props.cssClass === defaultCSS) {
        return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: _facebook2.default } });
      }
      return false;
    }
  }, {
    key: 'containerStyle',
    value: function containerStyle(renderProps) {
      var isProcessing = renderProps.isProcessing,
          isSdkLoaded = renderProps.isSdkLoaded,
          isDisabled = renderProps.isDisabled;


      var style = { transition: 'opacity 0.5s' };
      if (isProcessing || !isSdkLoaded || isDisabled) {
        style.opacity = 0.6;
      }
      return (0, _assign2.default)(style, this.props.containerStyle);
    }
  }, {
    key: 'renderOwnButton',
    value: function renderOwnButton(renderProps) {
      var _props = this.props,
          cssClass = _props.cssClass,
          size = _props.size,
          icon = _props.icon,
          textButton = _props.textButton,
          typeButton = _props.typeButton,
          buttonStyle = _props.buttonStyle;
      var onClick = renderProps.onClick,
          isDisabled = renderProps.isDisabled;


      var isIconString = typeof icon === 'string';
      var optionalProps = {};
      if (isDisabled && _shouldAddDisabledProp(this.props.tag)) {
        optionalProps.disabled = true;
      }
      return _react2.default.createElement(
        'span',
        { style: this.containerStyle(renderProps) },
        isIconString && _react2.default.createElement('link', {
          rel: 'stylesheet',
          href: 'https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css'
        }),
        _react2.default.createElement(
          this.props.tag,
          (0, _extends3.default)({
            type: typeButton,
            className: cssClass + ' ' + size,
            style: buttonStyle,
            onClick: onClick
          }, optionalProps),
          icon && isIconString && _react2.default.createElement('i', { className: 'fa ' + icon }),
          icon && !isIconString && icon,
          textButton
        ),
        this.style()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var onCustomFacebookButtonClick = this.props.onCustomFacebookButtonClick;

      var propsForRender = {
        onClick: onCustomFacebookButtonClick,
        isDisabled: false,
        isProcessing: false,
        isSdkLoaded: true
      };

      return !onCustomFacebookButtonClick ? _react2.default.createElement(_FacebookLogin2.default, (0, _extends3.default)({}, this.props, { render: function render(renderProps) {
          return _this2.renderOwnButton(renderProps);
        } })) : this.renderOwnButton(propsForRender);
    }
  }]);
  return FacebookLoginWithButton;
}(_react2.default.Component), _class.propTypes = {
  textButton: _react.PropTypes.string,
  typeButton: _react.PropTypes.string,
  size: _react.PropTypes.string,
  cssClass: _react.PropTypes.string,
  icon: _react.PropTypes.any,
  containerStyle: _react.PropTypes.object,
  buttonStyle: _react.PropTypes.object,
  onCustomFacebookButtonClick: _react.PropTypes.func,
  tag: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func])
}, _class.defaultProps = {
  textButton: 'Login with Facebook',
  typeButton: 'button',
  size: 'metro',
  fields: 'name',
  cssClass: 'kep-login-facebook',
  tag: 'button'
}, _temp);
exports.default = FacebookLoginWithButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FacebookLoginButton/FacebookLogin/FacebookLoginWithButton.js
// module id = 1952
// module chunks = 0